import { twMerge } from 'tailwind-merge';
import { QuestionTypeEnum } from '@/models/Question';
import { OrderingResultItem } from '@/components/question/view/primitives/correction/OrderingResultItem';
import { QuestionViewPropsFor } from '@/components/question/view/types';
import { useOrderingCorrection } from '@/components/question/view/typologies/ordering/useOrderingCorrection';

export function OrderingCorrectionView(
  props: QuestionViewPropsFor<QuestionTypeEnum.DND_ORDENATION>,
) {
  const { entries, flow } = useOrderingCorrection(props);

  return (
    <div
      className={twMerge(
        'flex w-full gap-2 border border-dashed border-secondary rounded-lg p-5 min-h-12',
        flow === 'vertical' ? 'flex-col' : 'flex-row flex-wrap',
      )}
    >
      {entries.map(entry => (
        <OrderingResultItem key={entry.id} entry={entry} />
      ))}
    </div>
  );
}
